export const Copy = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4615 7H8.53846C7.68879 7 7 7.68879 7 8.53846V15.4615C7 16.3112 7.68879 17 8.53846 17H15.4615C16.3112 17 17 16.3112 17 15.4615V8.53846C17 7.68879 16.3112 7 15.4615 7Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30769 11H2.53846C2.13044 11 1.73912 10.8379 1.4506 10.5494C1.16209 10.2609 1 9.86956 1 9.46154V2.53846C1 2.13044 1.16209 1.73912 1.4506 1.4506C1.73912 1.16209 2.13044 1 2.53846 1H9.46154C9.86956 1 10.2609 1.16209 10.5494 1.4506C10.8379 1.73912 11 2.13044 11 2.53846V3.30769"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
